import { Alpine as AlpineType } from 'alpinejs';

export default (Alpine: AlpineType) => {
  Alpine.data('tooltip', () => ({
    isOpen: false,

    get isTouchEnabled() {
      return ('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0);
    },

    mousemove(e: any) {
      if (!this.isTouchEnabled) {
        this.isOpen = true;
        this.$refs.tooltip.style.top = `${e.pageY + 5}px`;
        this.$refs.tooltip.style.left = `${e.pageX + 5}px`;
      }
    },
    mouseleave() {
      if (!this.isTouchEnabled) {
        this.isOpen = false;
      }
    },
    touch() {
      if (this.isTouchEnabled) {
        this.isOpen = !this.isOpen;
      }
    }
  }));
};